import React from "react";
import { Card, Stack, Timeline } from "@bookingcom/bui-react";
import { MagnifyingGlassIcon, PlaneTripIcon, TicketIcon, TransportAirplaneDepartIcon, TravelCreditIcon } from "@bookingcom/bui-assets-react/streamline";
import { Divider } from "@bookingcom/bui-react";
import styles from "./FlightCampaignTCBannerModal.module.css";
import { useSpringDeal } from "../../../hooks/useSpringDeal.js";
import { useSummerDeal } from "../../../hooks/useSummerDeal.js";
export const FlightCampaignTCBannerModalContent = ({ campaignBanner }) => {
    const { isSpringDealExp } = useSpringDeal();
    const { isSummerDealExp } = useSummerDeal();
    const isSeasonalDealExp = isSpringDealExp || isSummerDealExp;
    const bulletItems = campaignBanner.action.content.filter((item) => item.itemType === "BULLET");
    const paragraphItems = campaignBanner.action.content.filter((item) => item.itemType === "PARAGRAPH");
    const timeLineItems = campaignBanner.action.timeline
        ? [
            {
                childrenText: campaignBanner.action.timeline.firstStepText,
                marker: isSeasonalDealExp ? MagnifyingGlassIcon : TicketIcon
            },
            {
                childrenText: campaignBanner.action.timeline.secondStepText,
                marker: TravelCreditIcon
            },
            {
                childrenText: campaignBanner.action.timeline.thirdStepText,
                marker: isSeasonalDealExp ? TransportAirplaneDepartIcon : PlaneTripIcon
            }
        ].map(({ childrenText, marker }) => ({
            children: React.createElement("div", { className: styles.timeLineItem }, childrenText),
            marker,
            markerColor: "brand_primary",
            lineVariant: "dashed"
        }))
        : [];
    return (React.createElement(Card, { className: styles.contentContainer },
        React.createElement(Stack, { direction: "column", justifyContent: "start", gap: 0 },
            timeLineItems.length > 0 && (React.createElement("div", { className: styles.timeLineContainer },
                React.createElement(Timeline, { className: styles.timeline }, timeLineItems.map((timeLineItem, index) => (React.createElement(Timeline.Item, { key: `kTimeLineItem-${index}`, ...timeLineItem })))),
                React.createElement(Divider, { className: styles.timeLineDivider }))),
            React.createElement("div", { className: styles.contentTitle }, campaignBanner.action.contentTitle),
            bulletItems.length > 0 && (React.createElement("ul", { className: styles.contentItemList }, bulletItems.map((contentItem, index) => (React.createElement("li", { key: `kContentBullet-${index}`, className: styles.contentItemBullet }, contentItem.text))))),
            paragraphItems.map((contentItem, index) => (React.createElement("p", { key: `kContentParagraph-${index}`, className: styles.contentItemParagraph }, contentItem.text))))));
};
